import { HttpResponse, httpService } from '../core/http'
import {
  NonPaginatedResponseData,
  PaginatedRequest,
  PaginatedResponseData
} from '../core/interfaces'
import {
  Opportunity,
  OpportunityFilter,
  OpportunityNexContactFilter,
  OpportunityToUpdate
} from '../entities'
import { OpportunityCampaign } from '../entities/opportunity-campaign'
import { OpportunityConecpt } from '../entities/opportunity-concept'
import { OpportunityEvent } from '../entities/opportunity-event'
import { OpportunityToSave } from '../entities/opportunityToSave'

export const getAllOpportunities = async (
  query: PaginatedRequest<OpportunityFilter>
): Promise<PaginatedResponseData<Opportunity>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get('/opportunities', {
      params: {
        ...query
      }
    })

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOpportunityById = async (
  id: string
): Promise<NonPaginatedResponseData<Opportunity>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/opportunities/${id}`
    )
    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getNextContacts = async (
  query: PaginatedRequest<OpportunityFilter>
): Promise<PaginatedResponseData<Opportunity>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get('/opportunities', {
      params: {
        ...query
      }
    })

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOpportunityNexContact = async (
  query: PaginatedRequest<OpportunityNexContactFilter>
): Promise<PaginatedResponseData<Opportunity>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/opportunities/next-contacts',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOpportunityConcepts = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<OpportunityConecpt>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/opportunities/concepts',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOpportunityCampaigns = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<OpportunityCampaign>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/opportunities/campaigns',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOpportunityEvents = async (
  query: PaginatedRequest<any>
): Promise<PaginatedResponseData<OpportunityEvent>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      '/opportunities/events',
      {
        params: {
          ...query
        }
      }
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const createOpportunity = async (
  payload: OpportunityToSave
): Promise<any> => {
  try {
    const httpResponse: HttpResponse = await httpService.post(
      '/opportunities',
      payload
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const updateOpportunity = async (
  payload: OpportunityToUpdate & { id: number }
): Promise<any> => {
  try {
    const httpResponse: HttpResponse = await httpService.put(
      `/opportunities/${payload.id}`,
      payload
    )

    return httpResponse.data
  } catch (error) {
    return error
  }
}

export const getOpportunityOrderById = async (
  query: any
): Promise<NonPaginatedResponseData<any>> => {
  try {
    const httpResponse: HttpResponse = await httpService.get(
      `/opportunities/${query.id}/orders`,
      {
        params: { ...query }
      }
    )
    return httpResponse.data
  } catch (error) {
    return error
  }
}
